<template>
	<div>
        <div class="row">
			<div class="col-md-12">
                <el-card class="box-card col-md-12 mb-4" shadow="hover">
                    <div slot="header" class="clearfix">
                        <h4>Bag Replacement</h4>
                    </div>
                    <div>
                        <el-form label-position="top" label-width="100px">
                            <div class="row">
                                <div class="col-md-5">	
                                    <el-form-item label="Station">
                                        <el-select v-model="stationid" clearable filterable placeholder="Select Station" size="small" style="width:100%;">
                                            <el-option v-for="item7 in spbu.list" :key="item7.StationId" :label="item7.StationName" :value="item7.StationId">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </div>
								<div class="col-md-5">	
									<el-form-item label="Date Range:">
										<div class="block">								
											<el-date-picker
											v-model="dateRange"
											type="daterange"
											align="right"
											size="small" 
											unlink-panels
											range-separator="-"
											start-placeholder="Start date"
											end-placeholder="End date"
											format="yyyy-MM-dd"
											value-format="yyyy-MM-dd"
											:picker-options="pickerOptions">
											</el-date-picker>
										</div>
									</el-form-item>
								</div>
                                <div class="col-md-2">	
                                    <el-form-item label=" ">
                                        <el-button type="primary" size="medium" :loading="loading.table" @click="applyFilter" style="width:100%;">Submit</el-button>
                                    </el-form-item>
                                </div>
							</div>
                            <div class="row">
                                
                            </div>
                        </el-form>
                    </div>
                    <div class="mt-0">
                        <ReportResultTable :reportname="'TodaySummaryReport'" :reportdata="reportdata" :loading="loading.table" :reporturl="urlRequestParams" :issuccess="loading.isSuccess" style="width:100%;"/> 
                    </div>
                </el-card>
            </div>
        </div>
    </div>
</template>


<script>
import Finance from '@/components/page/Finance.js'
import PieChart from '@/components/chart/Pie.js'
import { Rainbow, Rainbow3, Config, AxiosWithJar, Penanggalan } from '@/utility.js'
import ReportResultTable from '@/views/pages/ReportResultTable3.vue'
import Loader from '@/components/loader/Loader2.vue'


export default
{
	extends: Finance,
	components: { 
        ReportResultTable,
		//PieChart,
		//Loader,
	},

	data(){
		return {
            urlRequestParams: '',
            reportdata: [],
            stationid: '',
            plant: '',
            spbu: {
                list:[],
            },
			options: {

            },
            loading: {
                table: false,
                isSuccess: false,
            },
            date: { 
				Start: this.$route.query.dateStart ? this.$route.query.dateStart : Penanggalan().tahunSekarang,
				End: this.$route.query.dateEnd ? this.$route.query.dateEnd : Penanggalan().kemarin, 
			},
            dateRange: [this.$route.query.dateStart ? this.$route.query.dateStart : Penanggalan().tahunSekarang,this.$route.query.dateEnd ? this.$route.query.dateEnd : Penanggalan().kemarin], 
            pickerOptions: {
				shortcuts: [{
					text: 'Last week',
					onClick(picker) {
					const end = new Date();
					const start = new Date();
					start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
					picker.$emit('pick', [start, end]);
					}
				}, {
					text: 'Last month',
					onClick(picker) {
					const end = new Date();
					const start = new Date();
					start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
					picker.$emit('pick', [start, end]);
					}
				}, {
					text: 'Last 3 months',
					onClick(picker) {
					const end = new Date();
					const start = new Date();
					start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
					picker.$emit('pick', [start, end]);
					}
				}]
			},
        }
    },

    watch: {

    }, 

    computed: {
        
    },

    mounted() {
        this.$emit('childrenRoute');
        this.loadStationList()
    },

    methods: { 
        async loadStationList(type='') {
			this.urlRequestParams = Config().apiURL
            this.urlRequestParams += "/fuel2/station?"  + (type ? "&type=" + type : "") + (this.plant ? "&plant=" + this.plant : "") + (this.stationid ? "&station=" + this.stationid : "");
			await AxiosWithJar().get(this.urlRequestParams).then(result=>{
				if(result.data.data.length){
					this.spbu.list = result.data.data;
				}
			})
		},

        getData() {

        },

        applyFilter() {
            this.getData()
        },
    }
        
}

</script>